var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c("div", { staticClass: "row justify-center" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-5" },
          [
            _c(
              "q-card",
              { staticClass: "q-py-xl bg-white" },
              [
                _c("q-card-title", { staticClass: "text-center login-form" }, [
                  _c("img", { attrs: { src: _vm.login_logo } })
                ]),
                _c("q-card-separator"),
                _vm.register_others.recover_password_with_sms
                  ? _c(
                      "q-card-main",
                      { staticClass: "q-pa-sm" },
                      [
                        _c(
                          "q-stepper",
                          {
                            ref: "stepper",
                            staticClass: "row q-px-sm",
                            attrs: {
                              contractable: "",
                              "alternative-labels": "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "q-step",
                              {
                                staticClass: "col-12",
                                attrs: {
                                  name: "user_email",
                                  title: _vm.$t("email"),
                                  icon: "fal fa-paper-plane"
                                }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "recover_your_password_using_your_email"
                                      )
                                    )
                                  )
                                ]),
                                _c("q-input", {
                                  attrs: {
                                    "lower-case": "",
                                    "float-label": _vm.$t("email"),
                                    error: _vm.$v.user_email.$error
                                  },
                                  on: { input: _vm.$v.user_email.$touch },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.recoverPassword()
                                    }
                                  },
                                  model: {
                                    value: _vm.user_email,
                                    callback: function($$v) {
                                      _vm.user_email = $$v
                                    },
                                    expression: "user_email"
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 q-mt-md row justify-end"
                                  },
                                  [
                                    _c("vue-recaptcha", {
                                      ref: "recaptcha",
                                      staticClass: "q-mb-sm",
                                      attrs: {
                                        loadRecaptchaScript: false,
                                        sitekey: _vm.getSiteKeyRecaptcha
                                      },
                                      on: {
                                        verify: _vm.onVerifyRecaptcha,
                                        expired: _vm.onExpiredRecaptcha
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("q-btn", {
                                  staticClass: "full-width q-mt-md",
                                  attrs: {
                                    color: "primary",
                                    icon: "fal fa-paper-plane",
                                    label: _vm.$t("send_recovery_mail")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.recoverPassword()
                                    }
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row gutter-sm justify-end q-mt-sm"
                                  },
                                  [
                                    _c(
                                      "q-stepper-navigation",
                                      [
                                        _c("q-btn", {
                                          attrs: {
                                            label: _vm.$t("recover_by_sms")
                                          },
                                          on: {
                                            click: function() {
                                              return (
                                                (_vm.currentStep =
                                                  "user_phone"),
                                                _vm.$refs.stepper.next()
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-step",
                              {
                                staticClass: "col-12",
                                attrs: {
                                  name: "user_phone",
                                  title: _vm.$t("mobile_phone"),
                                  "active-icon": "fas fa-mobile-alt",
                                  icon: "fas fa-mobile-alt"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.currentStep = "user_phone"
                                  }
                                }
                              },
                              [
                                _c(
                                  "p",
                                  { staticClass: "q-mb-xs" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "recover_your_password_using_your_phone_number"
                                        )
                                      )
                                    ),
                                    _c("q-icon", {
                                      staticClass: "q-ml-md",
                                      staticStyle: {
                                        "font-size": "1.5em",
                                        transform: "rotate(20deg)"
                                      },
                                      attrs: {
                                        name: "fal fa-mobile-android",
                                        size: "xl"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("q-input", {
                                  attrs: {
                                    "float-label": _vm.$t("document_cpf"),
                                    error: _vm.$v.user_document.$error
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.user_document &&
                                      _vm.user_document.length > 7
                                        ? _vm.getPhoneByDocument()
                                        : ""
                                    }
                                  },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      _vm.user_document &&
                                      _vm.user_document.length > 7
                                        ? _vm.getPhoneByDocument()
                                        : ""
                                    }
                                  },
                                  model: {
                                    value: _vm.user_document,
                                    callback: function($$v) {
                                      _vm.user_document = $$v
                                    },
                                    expression: "user_document"
                                  }
                                }),
                                _vm.user_document_found && !_vm.phone_mismatch
                                  ? _c(
                                      "div",
                                      [
                                        _c("p", { staticClass: "q-mt-sm" }, [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "we_have_found_the_phone_number"
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.received_phone))
                                          ]),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "for_the_document_registered"
                                                )
                                              ) +
                                              "\n                                "
                                          )
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "if_this_is_your_phone_confirm_below"
                                              )
                                            )
                                          )
                                        ]),
                                        _c("q-input", {
                                          attrs: {
                                            "float-label": _vm.$t(
                                              "phone_type_info"
                                            ),
                                            error: _vm.$v.user_phone.$error
                                          },
                                          on: {
                                            input: _vm.$v.user_phone.$touch
                                          },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.sendPhoneNumber()
                                            }
                                          },
                                          model: {
                                            value: _vm.user_phone,
                                            callback: function($$v) {
                                              _vm.user_phone = $$v
                                            },
                                            expression: "user_phone"
                                          }
                                        }),
                                        _c("q-btn", {
                                          staticClass: "full-width q-mt-md",
                                          attrs: {
                                            color: "primary",
                                            icon: "far fa-comment-alt-lines",
                                            label: _vm.$t("send_recovery_code")
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.sendPhoneNumber()
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.user_document_not_found &&
                                _vm.user_document &&
                                _vm.user_document.length >= 8 &&
                                !_vm.phone_mismatch
                                  ? _c("div", [
                                      _c("p", { staticClass: "q-mt-sm" }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "we_have_not_found_the_phone_number"
                                              )
                                            ) +
                                            "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "for_the_document_registered"
                                              )
                                            ) +
                                            "\n                                "
                                        )
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("please_check_your_document")
                                          )
                                        )
                                      ]),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "full-width",
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push({
                                                name: "login-help"
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("need_help") + "?")
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.phone_mismatch
                                  ? _c("div", [
                                      _c("p", { staticClass: "q-mt-md" }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "phone_mismatch_you_will_be_redirected"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row gutter-sm justify-start q-mt-sm"
                                  },
                                  [
                                    _c(
                                      "q-stepper-navigation",
                                      [
                                        _c("q-btn", {
                                          attrs: { label: _vm.$t("back") },
                                          on: {
                                            click: function() {
                                              return (
                                                (_vm.currentStep =
                                                  "user_email"),
                                                _vm.$refs.stepper.previous()
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-step",
                              {
                                staticClass: "col-12",
                                attrs: {
                                  name: "code_confirmation",
                                  title: _vm.$t("code"),
                                  "active-icon": "fal fa-barcode-alt",
                                  icon: "fal fa-barcode-alt"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "q-mb-xs" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert_the_code_you_received_on_your_phone"
                                            )
                                          )
                                        ),
                                        _c("q-icon", {
                                          staticClass: "q-ml-sm",
                                          staticStyle: {
                                            "font-size": "1.5em",
                                            transform: "rotate(20deg)"
                                          },
                                          attrs: {
                                            name: "fal fa-mobile-android",
                                            size: "xl"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("q-input", {
                                      attrs: {
                                        "float-label": _vm.$t("recovery_code"),
                                        debounce: "1000"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.confirmation_code.length >= 6
                                            ? _vm.confirmCode()
                                            : ""
                                        }
                                      },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.confirmCode()
                                        }
                                      },
                                      model: {
                                        value: _vm.confirmation_code,
                                        callback: function($$v) {
                                          _vm.confirmation_code = $$v
                                        },
                                        expression: "confirmation_code"
                                      }
                                    }),
                                    _c("q-btn", {
                                      staticClass: "full-width q-mt-md",
                                      attrs: {
                                        color: "primary",
                                        icon: "fal fa-paper-plane",
                                        label: _vm.$t("send_recovery_code")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmCode()
                                        }
                                      }
                                    }),
                                    !_vm.code_mismatch
                                      ? _c(
                                          "p",
                                          {
                                            staticClass: "q-mt-md",
                                            on: {
                                              click: function($event) {
                                                return _vm.sendPhoneNumber()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t("code_not_received") +
                                                    "?"
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c("strong", [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "resend_recovery_code"
                                                      )
                                                    )
                                                  ),
                                                  _c("q-icon", {
                                                    staticClass: "q-ml-sm",
                                                    staticStyle: {
                                                      "font-size": "1.2em"
                                                    },
                                                    attrs: {
                                                      name: "fal fa-sms",
                                                      size: "xl"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.code_mismatch
                                      ? _c("div", [
                                          _vm.code_mismatch
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass: "q-mt-md",
                                                  on: {
                                                    click: function() {
                                                      return (
                                                        (_vm.confirmation_code =
                                                          ""),
                                                        (_vm.code_mismatch = false),
                                                        _vm.sendPhoneNumber()
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "recovery_code_mismatch"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                  _c("strong", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          cursor: "pointer"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "resend_recovery_code"
                                                            )
                                                          )
                                                        ),
                                                        _c("q-icon", {
                                                          staticClass:
                                                            "q-ml-sm",
                                                          staticStyle: {
                                                            "font-size": "1.2em"
                                                          },
                                                          attrs: {
                                                            name: "fal fa-sms",
                                                            size: "xl"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row gutter-sm justify-start q-mt-sm"
                                            },
                                            [
                                              _c(
                                                "q-stepper-navigation",
                                                [
                                                  _c("q-btn", {
                                                    attrs: {
                                                      label: _vm.$t("back")
                                                    },
                                                    on: {
                                                      click: function() {
                                                        return (
                                                          (_vm.currentStep =
                                                            "user_email"),
                                                          _vm.$refs.stepper.previous(),
                                                          _vm.$refs.stepper.previous()
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "q-card-main",
                      [
                        _c("q-input", {
                          attrs: {
                            "lower-case": "",
                            "float-label": _vm.$t("email"),
                            error: _vm.$v.user_email.$error
                          },
                          on: { input: _vm.$v.user_email.$touch },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.recoverPassword()
                            }
                          },
                          model: {
                            value: _vm.user_email,
                            callback: function($$v) {
                              _vm.user_email = $$v
                            },
                            expression: "user_email"
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "col-12 q-mt-md row justify-center" },
                          [
                            _c("vue-recaptcha", {
                              ref: "recaptcha",
                              staticClass: "q-mb-sm",
                              attrs: {
                                loadRecaptchaScript: false,
                                sitekey: _vm.getSiteKeyRecaptcha
                              },
                              on: {
                                verify: _vm.onVerifyRecaptcha,
                                expired: _vm.onExpiredRecaptcha
                              }
                            })
                          ],
                          1
                        ),
                        _c("q-btn", {
                          staticClass: "full-width q-mt-md",
                          attrs: {
                            color: "primary",
                            icon: "fal fa-key",
                            label: _vm.$t("recover_password")
                          },
                          on: {
                            click: function($event) {
                              return _vm.recoverPassword()
                            }
                          }
                        })
                      ],
                      1
                    ),
                _c("q-card-separator"),
                _c(
                  "q-card-actions",
                  [
                    _c("q-btn", {
                      staticClass: "full-width q-my-sm",
                      attrs: {
                        color: "tertiary",
                        icon: "fas fa-chevron-left",
                        label: _vm.$t("back")
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({ name: "login" })
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "text-right q-pa-sm" }, [
              _c(
                "p",
                {
                  staticClass: "full-width",
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "login-help" })
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("help")))]
              )
            ])
          ],
          1
        )
      ]),
      _c(
        "q-dialog",
        {
          attrs: { cancel: false },
          on: {
            ok: function($event) {
              _vm.show_error = false
            }
          },
          model: {
            value: _vm.show_error,
            callback: function($$v) {
              _vm.show_error = $$v
            },
            expression: "show_error"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("recover_password_error")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("user_not_found_or_incorrect")))
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { cancel: false },
          on: {
            ok: function($event) {
              return _vm.recoverPasswordSuccess()
            }
          },
          model: {
            value: _vm.show_success,
            callback: function($$v) {
              _vm.show_success = $$v
            },
            expression: "show_success"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("recover_password")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("email_sent_recover_information")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }